import {InterfaceEntity, InterfaceEntityPagination} from '@store/settings/interface/interface.model';
import {interfaceStore} from '@store/settings/interface/interface.store';
import {GridSortItem} from '@mui/x-data-grid-pro';
import {catchError, from, map, Observable, tap} from 'rxjs';
import APIAxios, {APIRoutes} from '@api/axios.api';
import {AxiosError, AxiosResponse} from 'axios';
import SnackError from '@utils/error.utils';
import {Pagination} from '@store/common/pagination.model';
import {setEntities} from '@ngneat/elf-entities';
import {setPage, updatePaginationData} from '@ngneat/elf-pagination';
import {getInterfaceEntitiesDataSource} from '@store/settings/interface/interface.requests';

export class InterfaceService {
  store = interfaceStore;

  setSort = (sort: GridSortItem) => this.store.update((state) => ({...state, sort}));
  setPagination = (name: string) => (value: number) => this.store.update((state) => ({
    ...state,
    tablePagination: {
      ...state.tablePagination,
      [name]: value,
    },
  }));

  updateFilters = (name: string) => (value: any) => this.store.update((state) => ({
    ...state,
    filters: {
      ...state.filters,
      [name]: value,
    }
  }));

  setFilters = (name: string) => (value: any) =>
    this.store.update((state) => ({
      ...state,
      filters: {
        ...state.filters,
        [name]: value,
      },
    }));

  getInterfaceEntities = (): Observable<InterfaceEntityPagination> => {
    const {tablePagination, filters: {entityType, search}} = this.store.getValue();

    return from(APIAxios({
      ...APIRoutes.GETInterfaceEntities(),
      params: {
        entityType,
        page: tablePagination.page,
        limit: tablePagination.limit,
        searchString: search,
      }
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<InterfaceEntityPagination>) => {
          return response.data;
        }),
        tap((entitiesPagination) => {
          const paginationData = Pagination.toPaginationData(entitiesPagination, tablePagination.page);

          this.store.update(
            setEntities(entitiesPagination.data),
            updatePaginationData(paginationData),
            setPage(paginationData.currentPage, entitiesPagination.data.map((e) => e.id)),
            getInterfaceEntitiesDataSource.setSuccess(),
          );
        }),
        getInterfaceEntitiesDataSource.trackRequestStatus(),
      );
  };

  createInterfaceEntity(interfaceEntity: InterfaceEntity) {
    return from(APIAxios({
      ...APIRoutes.POSTInterfaceEntities(),
      data: interfaceEntity,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<InterfaceEntityPagination>) => {
          return response.data;
        }),
      );
  }
}

export const interfaceService = new InterfaceService();
